






























import {
  Vue,
  Prop,
  Component
} from "@/shared/vuepack";
import { formatCurrency } from "@/shared/currency";
import { useHsabInvestmentStore } from "@/shared/store/hsabInvestment";

@Component
export default class HsabInvestmentAccountRedirectLink extends Vue {
  hsabInvestmentStore = useHsabInvestmentStore();

  @Prop({ required: true })
  label: string;

  @Prop({ required: false })
  balance: number;

  get accountBalance (): string {
    if (this.balance) {
      return formatCurrency(this.balance);
    }

    return "0.00";
  }

  created (): void {
    this.hsabInvestmentStore.loadInvestmentIframe();
  }

  onClick () {
    if (!this.hsabInvestmentStore.iframeLoaded) {
      return;
    }
    window.open(this.hsabInvestmentStore.iframeUrl, "_blank");
  }
}
